var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { marketingConsentVar, stateVar } from "common/Auth/Utils/state";
import { InteractiveCategory, } from "core/codegen/types";
import { PageSubType, PageType } from "core/types";
import { config } from "core/utils/config";
import { Env } from "core/utils/env";
import { globalPageInfo, } from "./data";
export function pushPageView(pageInfo) {
    if (Env.isServer)
        return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(__assign({ event: "PageView" }, enforceObjectStructure(pageInfo)));
}
export function pushSearchResultsView(searchInfo, type, filters) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(__assign(__assign({ user: getUserObject(), event: type }, searchInfo), { 
        // eslint-disable-next-line camelcase
        search_filters: filters }));
}
export function pushProductClick(product) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        user: getUserObject(),
        event: "product_click",
        ecommerce: {
            click: __assign({}, product),
        },
        list: {
            // eslint-disable-next-line camelcase
            ab_group: "default",
        },
    });
}
export function pushVtmBannerClick(product) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        user: getUserObject(),
        event: "information_click",
        event_category: "vtm go clicks",
        event_action: "homepage-banner",
        event_label: getEventLabel(), // e.g. Home or Familie
    });
}
export function pushVtmGoClick(product) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        user: getUserObject(),
        event: "routing_click",
        event_category: "vtm go clicks",
        event_action: product.actionField.list,
        event_label: getEventLabel(), // e.g. Home or Familie
    });
}
export function pushVtmGoPlusClick(product) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        user: getUserObject(),
        event: "routing_click",
        event_category: "vtm go plus clicks",
        event_action: product.actionField.list,
        event_label: getEventLabel(), // e.g. Home or Familie
    });
}
export function pushProductImpression(impressions) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        user: getUserObject(),
        event: "product_impression",
        ecommerce: {
            impressions: impressions,
        },
    });
}
export var trackWebVitals = function (_a) {
    var name = _a.name, delta = _a.delta, id = _a.id;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        user: getUserObject(),
        event: "web-vitals",
        // eslint-disable-next-line camelcase
        event_category: "Web Vitals",
        // eslint-disable-next-line camelcase
        event_action: name,
        // eslint-disable-next-line camelcase
        event_value: Math.round(name === "CLS" ? delta * 1000 : delta),
        // eslint-disable-next-line camelcase
        event_label: id,
    });
};
function getUserObject() {
    var authState = stateVar();
    var consentGiven = marketingConsentVar();
    if (authState.kind === "LoggedIn" && consentGiven) {
        return {
            account_id: authState.data.sub,
        };
    }
    return undefined;
}
function getEventLabel() {
    var pageInfo = globalPageInfo();
    if (pageInfo && pageInfo.kind === "Matched") {
        if (pageInfo.page.type === "Program") {
            return pageInfo.page.title;
        }
        return pageInfo.page.type;
    }
}
function programToProgramInfo(program) {
    return {
        id: program.uuid,
        title: program.title,
        pubDate: program.publishedAt,
    };
}
function enforceObjectStructure(pageInfo) {
    return {
        page: __assign({ id: null, title: null, pubDate: null, brand: null, language: null, message: null }, pageInfo.page),
        user: getUserObject(),
        program: typeof pageInfo.program !==
            "undefined"
            ? pageInfo.program
            : null,
    };
}
export function pageToRegularPageInfo(page) {
    var pageForTracking = {
        id: page.uuid,
        title: page.title,
        type: page.type,
        pubDate: page.publishedAt,
        brand: config.brand,
        language: config.language,
    };
    switch (page.type) {
        case PageType.HomePage:
            return { page: pageForTracking };
        case PageType.ProgramOverview:
            return {
                page: __assign(__assign({}, pageForTracking), { type: "program overview" }),
            };
        case PageType.Program:
            return {
                page: pageForTracking,
                program: programToProgramInfo(page),
            };
        case PageType.Interactive:
            return __assign({ page: __assign(__assign({}, pageForTracking), { subType: categoryToSubType(page.category) }) }, (page.program !== null
                ? { program: programToProgramInfo(page.program) }
                : {}));
        case PageType.TicketOverview:
            return { page: pageForTracking };
        default:
            return __assign({ page: pageForTracking }, (page.program !== null
                ? { program: programToProgramInfo(page.program) }
                : {}));
    }
}
export function getVariant(item) {
    if ("__typename" in item && item.__typename === "Program") {
        return getProgramVariant(item);
    }
    if ("kind" in item && item.kind === "Channel") {
        return getProgramVariant(item);
    }
    return undefined;
}
export function getProgramVariant(item) {
    return item.vtmgoRedirectEnabled ? config.tracking.vtmGo.program : undefined;
}
function categoryToSubType(category) {
    switch (category) {
        case InteractiveCategory.Game:
            return PageSubType.Game;
        case InteractiveCategory.Voting:
            return PageSubType.Voting;
        case InteractiveCategory.SecondScreen:
            return PageSubType.SecondScreen;
        case InteractiveCategory.Ticket:
            return PageSubType.Ticket;
        default:
            return PageSubType.Other;
    }
}
